export default __webpack_public_path__ + "static/media/blip-wow.1c406aa1.svg";